'use client';

import { useRouter } from 'next/navigation';
import { useTranslation as t } from '../hooks/useTranslation';
import { EpErrorPage } from '../components/EpErrorPage';
import { ROUTE_HOMEPAGE } from '../constants/urlConstants';
import { useTranslationStore } from '../stores';
import { globalizationService } from '@/services/globalizationService';

export default function NotFound() {
  const { addTranslations } = useTranslationStore((state) => state);
  const route = useRouter();

  const { translations } =
    globalizationService.getTranslationsByTagUserNotLogged('global', (data) => addTranslations({ global: data }),
    );

  return (
    <EpErrorPage
      errorPageStatus={404}
      errorPageButtonOnClickFunc={() => route.push(ROUTE_HOMEPAGE)}
      translations={{
        titleError401: t(translations, 'Unauthorized access'),
        messageError401: t(
          translations,
          'Oops! It seems that you do not have access to this page. Please contact our support for more information.',
        ),
        titleError403: t(translations, 'Access denied'),
        messageError403: t(
          translations,
          'You do not seem to be authorized to access this page. Please contact our support for more information.',
        ),
        titleError404: t(translations, 'Resource not found'),
        messageError404: t(
          translations,
          `Oops! We're sorry, but we were not able to locate the page you requested. Please try to return to the main menu.`,
        ),
        titleErrorDefault: t(translations, 'This page is not working'),
        messageErrorDefault: t(
          translations,
          `This is unexpected, but don't worry, our team is working on solving the problem.`,
        ),
        backToHomeButtonText: t(translations, 'Back to the home page'),
      }}
    />
  );
}
